import * as React from "react";
import {IAppState} from "./App";
import {ScenarioUtil} from "./Scenario";
import {DeckComponent} from "./DeckComponent";
import { CardType } from "./Card";
import { CardUtil } from "./CardUtil";

export interface IVictoryDisplayProps {
    state: IAppState;
    onClose: () => void;
}
export class VictoryDisplayComponent extends React.Component<IVictoryDisplayProps, any> {
    render() {
        const cards = ScenarioUtil.getVictoryCards(this.props.state.scenarioState).map(c => {

            c.faceUp = c.type!==CardType.Location;
            return (<DeckComponent key={CardUtil.getKey(c)} deck={{ cards: [c] }} settings={{
                toolbar: { zoom: true, flip: false }
            }} horizontal={false}/>);
        });
        return (
            <div className="container-fluid">
                <div className="col col-md-12 p-t-30">
                    <div className="summary summary-victory-display">
                        <div className="content-box">
                            <div className="row">
                                <div className="col col-md-12">
                                    <h1>Victory Display:</h1>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col col-md-12">
                                    {cards}
                                </div>
                            </div>
                            <div className="clearfix">
                                <div className="pull-right">
                                    <button onClick={() => this.props.onClose()}>Continue</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
